/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goals_EyebrowInputs */

const en_funnel_ob_goals_eyebrow = /** @type {(inputs: Funnel_Ob_Goals_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So we show you what matters`)
};

const es_funnel_ob_goals_eyebrow = /** @type {(inputs: Funnel_Ob_Goals_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para mostrarte lo que te importa`)
};

/**
* | output |
* | --- |
* | "So we show you what matters" |
*
* @param {Funnel_Ob_Goals_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goals_eyebrow = /** @type {((inputs?: Funnel_Ob_Goals_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goals_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goals_eyebrow(inputs)
	return en_funnel_ob_goals_eyebrow(inputs)
});